
import { defineComponent, ref, onMounted } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb"
import { ElMessage } from "element-plus"
import GrantModal from "./GrantModal.vue"
import { MallCoupon } from "@/store/modules/MallCouponModule"

export default defineComponent({
  components: {
    GrantModal
  },
  setup() {
    onMounted(() => {
      setCurrentPageBreadcrumbs("商城优惠券列表", ["商城优惠券管理;mall_coupons"])
    })

    const store = useStore()
    const tableData = ref<MallCoupon[]>([])

    const formData = ref({
      name: '',
      coupon_type: '',
      status: ''
    })

    const page = ref({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0,
    })

    const grantModalVisible = ref(false)
    const selectedCoupon = ref<MallCoupon | null>(null)

    const query = () => {
      store
        .dispatch(Actions.GET_MALL_COUPONS, { ...formData.value, ...page.value })
        .then(() => {
          tableData.value = store.getters.currentMallCoupons
          page.value.totalResult = store.getters.currentMallCouponCount
        })
        .catch(() => {
          ElMessage.error('获取优惠券列表失败')
        })
    }

    query()

    const submitEvent = () => {
      page.value.currentPage = 1
      query()
    }

    const onPageChange = (e) => {
      page.value.currentPage = e.currentPage
      query()
    }

    const onReset = () => {
      formData.value = {
        name: '',
        coupon_type: '',
        status: ''
      }
      page.value.currentPage = 1
      query()
    }

    const formatDate = (dateStr: string) => {
      if (!dateStr) return ''
      return dateStr.slice(0, 16).replace('T', ' ')
    }

    const openGrantModal = (coupon: MallCoupon) => {
      selectedCoupon.value = coupon
      grantModalVisible.value = true
    }

    const onGrantSuccess = () => {
      grantModalVisible.value = false
      query()
    }

    return {
      tableData,
      formData,
      submitEvent,
      page,
      onPageChange,
      onReset,
      formatDate,
      grantModalVisible,
      selectedCoupon,
      openGrantModal,
      onGrantSuccess
    }
  },
})
